import { ProjectWizardContext } from 'context/Context';
import { useContext, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import UnitsTable from './components/units/UnitsTable';
import { UnitSidebar } from './components/units/UnitSidebar';
import { UnitHeader } from './components/units/UnitHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UnitForm } from './components/units/UnitForm';
import Flex from 'components/common/Flex';
import { Formik, Form as FormFormik } from 'formik';
import { UnitsSchema } from '../../validations/projectsValidation';
import { useEffect } from 'react';
import lodash from 'lodash';
import messageHandler from 'utils/messageHandler';

const Unidades = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef /* , form */ } =
    useContext(ProjectWizardContext);

  /* const [units, setUnits] = useState(data.units || []); */
  const [hideSidebar, setHideSidebar] = useState(false);
  const [activeUnit, setActiveUnit] = useState(0);

  const initialValues = {
    units: data.units || []
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={values => {
        const newUnits = values.units.map(unit => {
          const { price, expenses, covered_surface, total_surface, ...rest } =
            unit;

          return {
            ...rest,
            price: Number(price),
            expenses: Number(expenses),
            covered_surface: Number(covered_surface),
            total_surface: Number(total_surface)
          };
        });

        handleSubmit(
          { ...values, units: newUnits },
          lodash.isEqual({ ...values, units: newUnits }, initialValues)
        );
      }}
      validationSchema={UnitsSchema}
    >
      {({ setValues, values, errors, touched }) => {
        useEffect(() => {
          setStepStatus(prev => ({
            ...prev,
            ...values
          }));
        }, [values]);

        const setUnits = cb => {
          setValues(prev => ({ ...prev, units: cb(prev.units) }));
        };

        const units = values.units;

        const handleAddUnit = () => {
          const initialUnit = {
            name: '',
            property_type: 0,
            sub_property_type: 0,
            status: '',
            floor: '',
            number_letter: '',
            ambience: 0,
            covered_surface: '',
            total_surface: '',
            bathrooms: 0,
            toilettes: 0,
            currency: 1,
            price: '',
            expenses_currency: 1,
            expenses: ''
          };

          setUnits(prev => {
            if (prev.length) {
              return [...prev, initialUnit];
            } else {
              return [initialUnit];
            }
          });

          setActiveUnit(units.length);
        };

        const handleRemoveUnit = index => {
          if (index > 0) {
            setActiveUnit(index - 1);
          }

          setUnits(prev => [...prev.filter((_, i) => i !== index)]);
        };

        return (
          <FormFormik>
            {!units.length ? (
              <div className="w-100 d-flex justify-content-center">
                <Button
                  onClick={handleAddUnit}
                  className="d-flex gap-2 align-items-center justify-content-center"
                >
                  <FontAwesomeIcon icon="plus" className="fs-1" />
                  Agregar una unidad
                </Button>
              </div>
            ) : (
              <>
                <Card
                  className="card-chat overflow-hidden bg-white"
                  style={{ boxShadow: 'none', height: 'auto' }}
                >
                  <Card.Body as={Flex} className="p-0 h-100">
                    <UnitSidebar
                      units={units}
                      handleAddUnit={handleAddUnit}
                      handleRemoveUnit={handleRemoveUnit}
                      hideSidebar={hideSidebar}
                      setHideSidebar={setHideSidebar}
                      setActiveUnit={setActiveUnit}
                      activeUnitIndex={activeUnit}
                    />

                    <div className="w-100">
                      <UnitHeader
                        setHideSidebar={setHideSidebar}
                        activeUnitIndex={activeUnit}
                        activeUnit={units[activeUnit]}
                      />

                      <UnitForm
                        values={values}
                        setValues={setValues}
                        unit={units[activeUnit]}
                        setUnits={setUnits}
                        unitIndex={activeUnit}
                        touched={touched}
                        errors={errors}
                      />
                    </div>
                  </Card.Body>
                </Card>
                <hr />
                <h4 className="mb-3">Todas las unidades</h4>
                <div
                  style={{
                    overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch'
                  }}
                >
                  <UnitsTable units={units} />
                </div>{' '}
              </>
            )}

            <button
              onClick={() =>
                Object.keys(errors).length &&
                messageHandler(
                  'error',
                  'Uno o más campos son incorrectos. Por favor, corrija los errores para poder continuar.'
                )
              }
              hidden
              ref={yupSubmitRef}
            ></button>
          </FormFormik>
        );
      }}
    </Formik>
  );
};

export default Unidades;
